module.exports = __webpack_public_path__ + "img/concrete-hole-decal-24.da6c1871.png";